// Formato es-ES manual (independiente del soporte Intl del motor JS)
export const fmt = (n: number): string => {
  const neg = n < 0;
  const s = Math.round(Math.abs(n)).toString();
  const out = s.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return (neg ? '−' : '') + out;
};

export const fmtE = (n: number) => `${fmt(n)} €`;

export const fmtDec = (n: number, dec = 1): string => {
  const neg = n < 0;
  const v = Math.abs(n).toFixed(dec);
  const [i, d] = v.split('.');
  return (neg ? '−' : '') + i.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (d ? ',' + d : '');
};

export const fmtM = (n: number) => `${fmtDec(n / 1e6, 2)} M€`;
export const fmtK = (n: number) => `${fmt(n / 1e3)} k€`;
export const pct1 = (n: number) => `${fmtDec(n, 1)}%`;

export const hoy = () => {
  const dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  const d = new Date();
  const s = `${dias[d.getDay()]}, ${d.getDate()} de ${meses[d.getMonth()]}`;
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const saludo = () => {
  const h = new Date().getHours();
  return h < 7 ? 'Buenas noches' : h < 13 ? 'Buenos días' : h < 21 ? 'Buenas tardes' : 'Buenas noches';
};

/* Nombre de pila a partir del «nombre para mostrar» de Entra, que a menudo trae
   el puesto detrás («Alex Serna - Administrador de Sistemas»). Se corta por el
   guion y se queda con la primera palabra: es como te llamaría un compañero. */
export const primerNombre = (completo?: string | null): string => {
  const limpio = String(completo ?? '').split(/\s+[-–—]\s+/)[0].trim();
  const p = limpio.split(/\s+/).filter(Boolean)[0] ?? '';
  return p ? p.charAt(0).toUpperCase() + p.slice(1) : '';
};

/* Fecha corta para las listas: «2026-09-04» → «4 sep». Se construye a mano y no
   con `new Date(iso)`, porque eso interpreta la cadena en UTC y en Madrid puede
   restar un día — un vencimiento que cae el 1 se leería «31 ago». */
const MESES_CORTOS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun',
                      'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
export const fmtDiaMes = (iso?: string | null): string => {
  if (!iso) return '—';
  const [, m, d] = iso.split('-');
  const mes = MESES_CORTOS[Number(m) - 1];
  return mes ? `${Number(d)} ${mes}` : iso;
};
